import React, { useEffect, useState } from 'react'
import { PostExistFood } from '../../Api/BarestSupplierServices'
import { errorToast, succToast } from '../../Utils/Toast/Toast'
import Style from './SwitchButton.module.css'

const SwitchButton = ({item,updateList}) => {
    const[switchButton,setSwitchButton]=useState()
    useEffect(()=>{
        setSwitchButton(item.count==='0'?false:true)
    },[item.count])

    const handleSwitchChange=(id)=>{

            let info={
            product_id:id,
            count:item.count==='0' ? 1 : 0,
        }
        PostExistFood(info,(suc=>{
            if(suc.status===1){
                succToast(suc.message)
                updateList()
                setSwitchButton(!switchButton)
            }
            else{
                errorToast(suc.message)
            }
        }))
    }

    return (
        <div className={Style.customControl}>
            {!switchButton? 
                <h3 style={{color:"#FF6464", fontSize:".9rem"}}>ناموجود</h3> 
                :
                <h3 style={{color:"#00BB45", fontSize:".9rem"}}>موجود</h3> 
            }
            <input type='checkbox' className={Style.reactSwitchCheckbox} id={`react-switch-new${item.id}`}
            checked={switchButton}
            onChange={()=>handleSwitchChange(item.id)}
            />
            <label className={Style.reactSwitchLabel} htmlFor={`react-switch-new${item.id}`}  style={{background:!switchButton? "#FF6464" :"#00BB45"  }} >
                <span className={Style.reactSwitchButton} />
            </label>
        </div>
    )
}
export default SwitchButton
